<template>
  <div class="main dict-page">
    <div class="main_r">
        <div class="page-top">
          <div class="title_line">字典管理</div>
          <div class="filter-strip">
            <div class="filter-strip__fields">
              <div class="filter-field filter-field--compact">
                <label class="filter-field__label">字典分类</label>
                <el-select v-model="gvtype" placeholder="字典分类" size="small">
                  <el-option v-for="item in gvTypeList" :label="item" :value="item"></el-option>
                </el-select>
              </div>
              <div class="filter-field filter-field--compact">
                <label class="filter-field__label">字典名称</label>
                <el-input v-model="name" placeholder="请输入字典名称" clearable size="small"></el-input>
              </div>
              <div class="filter-field filter-field--compact">
                <label class="filter-field__label">字典数据</label>
                <el-input v-model="gv" placeholder="请输入字典数据" clearable size="small"></el-input>
              </div>
            </div>
            <div class="filter-strip__actions">
              <el-button type="primary" size="small" icon="el-icon-search" @click="clickQuery">查询</el-button>
              <el-button type="primary" size="small" plain icon="el-icon-refresh-left" @click="clickQueryReset">重置</el-button>
              <span class="filter-strip__sep"></span>
              <el-button type="primary" size="small" icon="el-icon-plus" @click="clickAdd">新增</el-button>
            </div>
          </div>
        </div>

        <div class="table-section">
          <div class="table-container">
            <el-table :data="dataList" ref="projecttable" style="width: 100%" class="dict-table" height="100%" :header-cell-style="{textAlign: 'center'}" :cell-style="{ textAlign: 'center' }" @sort-change="handleSortChange">
              <el-table-column prop="id" label="序号" width="85" sortable="custom" align="center"></el-table-column>
              <el-table-column prop="sortOrder" label="排序" width="85" sortable="custom" align="center"></el-table-column>
              <el-table-column prop="type" label="字典分类" width="120" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="name" label="字典名称" width="140" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="gv" label="字典数据" min-width="220" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column prop="gv2" label="字典数据" min-width="140" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column label="更新模式" width="115" align="center">
                <template v-slot="scope">
                  <el-tag v-if="scope.row.gv3 === 'forced'" type="danger" size="mini" effect="plain" class="dict-tag dict-tag--danger">强制更新</el-tag>
                  <el-tag v-else-if="scope.row.gv3 === 'optional'" type="success" size="mini" effect="plain" class="dict-tag dict-tag--success">可选更新</el-tag>
                  <span v-else class="dict-tag dict-tag--empty">-</span>
                </template>
              </el-table-column>
              <el-table-column prop="note" label="字典备注" min-width="160" sortable="custom" show-overflow-tooltip></el-table-column>
              <el-table-column label="英文名称" min-width="140" show-overflow-tooltip>
                <template v-slot="scope">
                  <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['en'] && translationMap[scope.row.id]['en']['name']) || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="德文名称" min-width="140" show-overflow-tooltip>
                <template v-slot="scope">
                  <span>{{ (translationMap[scope.row.id] && translationMap[scope.row.id]['de'] && translationMap[scope.row.id]['de']['name']) || '-' }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="Operation" label="操作" width="240" align="center" fixed="right">
                <template v-slot="scope">
                  <div class="action-group">
                    <el-tooltip class="item" effect="dark" content="详情" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-view" @click="clickDetail(scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="编辑" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-edit" @click="clickEdit(scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="编辑富文本" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-info" @click="clickUeditor(scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="翻译" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-s-opportunity" @click="clickI18n(scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="上移" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-top" @click="clickMoveUp(scope.$index, scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="下移" placement="top" :enterable="false">
                      <el-link :underline="false" type="primary" icon="el-icon-bottom" @click="clickMoveDown(scope.$index, scope.row)"></el-link>
                    </el-tooltip>
                    <el-tooltip class="item" effect="dark" content="删除" placement="top" :enterable="false">
                      <el-link :underline="false" type="danger" icon="el-icon-delete" @click="clickDelete(scope.row)"></el-link>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="dataListnum">
          </el-pagination>
        </div>

      <!-- 编辑信息 -->
      <el-dialog title="编辑信息" :visible.sync="dialogEdit" class="newAdd" :close-on-click-modal="false">
        <el-form :model="editForm">
          <el-form-item label="字典分类" :label-width="formLabelWidth" :required=true>
            <el-input v-model="editForm.type" autocomplete="off" placeholder="请输入字典分类"></el-input>
          </el-form-item>
          <el-form-item label="字典名称" :label-width="formLabelWidth" :required=true>
            <el-input v-model="editForm.name" autocomplete="off" placeholder="请输入字典名称"></el-input>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth" :required=true>
            <el-input v-model="editForm.gv" autocomplete="off" placeholder="请输入字典数据主"></el-input>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth">
            <el-input v-model="editForm.gv2" autocomplete="off" placeholder="请输入字典数据副"></el-input>
          </el-form-item>
          <el-form-item label="字典备注" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="editForm.note" autocomplete="off" placeholder="请输入字典备注"></el-input>
          </el-form-item>
          <el-form-item label="排序序号" :label-width="formLabelWidth">
            <el-input-number v-model="editForm.sortOrder" :min="1" controls-position="right"></el-input-number>
          </el-form-item>
          <el-form-item label="更新模式" :label-width="formLabelWidth"
            v-if="editForm.type === 'APP更新' || editForm.type === '固件更新'">
            <el-select v-model="editForm.gv3" placeholder="请选择更新模式">
              <el-option label="可选更新" value="optional"></el-option>
              <el-option label="强制更新" value="forced"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="GvUpdate(1)">确定</el-button>
          <el-button @click="dialogEdit = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 详情信息 -->
      <el-dialog title="详情信息" :visible.sync="dialogDetail" class="newAdd detailDialog" :close-on-click-modal="false">
        <el-form :model="detailForm">
          <el-form-item label="字典分类" :label-width="formLabelWidth">
            <div class="detailText">{{ detailForm.type || '-' }}</div>
          </el-form-item>
          <el-form-item label="字典名称" :label-width="formLabelWidth">
            <div class="detailText">{{ detailForm.name || '-' }}</div>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth">
            <div class="detailText detailTextArea">{{ detailForm.gv || '-' }}</div>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth">
            <div class="detailText">{{ detailForm.gv2 || '-' }}</div>
          </el-form-item>
          <el-form-item label="字典备注" :label-width="formLabelWidth">
            <div class="detailText detailTextArea">{{ detailForm.note || '-' }}</div>
          </el-form-item>
          <el-form-item label="更新模式" :label-width="formLabelWidth">
            <div class="detailText">{{ detailForm.gv3 === 'forced' ? '强制更新' : detailForm.gv3 === 'optional' ? '可选更新' : '-' }}</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogDetail = false">确定</el-button>
        </div>
      </el-dialog>

      <!-- 新增信息 -->
      <el-dialog title="新增信息" :visible.sync="dialogAdd" class="newAdd" :close-on-click-modal="false">
        <el-form :model="addForm">
          <el-form-item label="字典分类" :label-width="formLabelWidth" :required=true>
            <el-select v-model="addForm.type" placeholder="请选择字典分类" style="width: 100%">
              <el-option v-for="item in gvTypeList" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="字典名称" :label-width="formLabelWidth" :required=true>
            <el-input v-model="addForm.name" autocomplete="off" placeholder="请输入字典名称"></el-input>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth" :required=true>
            <el-input v-model="addForm.gv" autocomplete="off" placeholder="请输入字典数据主"></el-input>
          </el-form-item>
          <el-form-item label="字典数据" :label-width="formLabelWidth">
            <el-input v-model="addForm.gv2" autocomplete="off" placeholder="请输入字典数据副"></el-input>
          </el-form-item>
          <el-form-item label="字典备注" :label-width="formLabelWidth">
            <el-input type="textarea" v-model="addForm.note" autocomplete="off" placeholder="请输入字典备注"></el-input>
          </el-form-item>
          <el-form-item label="更新模式" :label-width="formLabelWidth"
            v-if="addForm.type === 'APP更新' || addForm.type === '固件更新'">
            <el-select v-model="addForm.gv3" placeholder="请选择更新模式">
              <el-option label="可选更新" value="optional"></el-option>
              <el-option label="强制更新" value="forced"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="GvInsert()">确定</el-button>
          <el-button @click="dialogAdd = false">取消</el-button>
        </div>
      </el-dialog>

      <!-- 翻译管理 -->
      <i18n-translation-dialog
        :visible.sync="dialogI18n"
        :entity-type="i18nEntityType"
        :entity-id="i18nEntityId"
        :fields="i18nFields">
      </i18n-translation-dialog>

      <!-- 编辑富文本弹窗 -->
      <el-dialog title="编辑富文" :visible.sync="dialogUeditor" width="80%" class="newAdd ueditor-dialog" :close-on-click-modal="false">
        <div class="ueditor-dialog-body">
          <VueUeditorWrap v-model="ueditorContent" :config="myConfig"></VueUeditorWrap>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="GvUpdate(2)">确定</el-button>
          <el-button @click="GoBack()">返回</el-button>
        </div>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import VueUeditorWrap from 'vue-ueditor-wrap'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
import I18nTranslationDialog from '@/components/I18nTranslationDialog.vue'
Vue.use(VueAxios, axios)

export default {
  components: {
    VueUeditorWrap,
    I18nTranslationDialog
  },
  data () {
    return {
      activeName: 'first',
      formLabelWidth: '120px',
      selectParentId: '',
      gvTypeList: [],
      gvtype: '固件更新',
      name: '',
      gv: '',
      dataList: [],
      dataListnum: 0,
      pageNo: 1,
      pageSize: 10,
      sortField: '',
      sortOrder: '',
      editForm: {
        id: '',
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: '',
        sortOrder: ''
      },
      detailForm: {
        id: '',
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: ''
      },
      ueditorContent:'',
      myConfig: {
        // 编辑器不自动被内容撑开
        autoHeightEnabled: false,
        // 初始容器高度
        initialFrameHeight: 500,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 上传文件接口
        serverUrl: '',
        // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
        UEDITOR_HOME_URL: '/UEditor/'
      },
      currentPage: 0,
      dialogEdit: false,
      dialogDetail: false,
      dialogAdd: false,
      dialogUeditor: false,
      addForm: {
        type: '',
        name: '',
        gv: '',
        gv2: '',
        gv3: '',
        note: ''
      },
      // 翻译管理
      dialogI18n: false,
      i18nEntityId: null,
      i18nEntityType: 'GV',
      i18nFields: [
        { name: 'name', label: '字典名称', type: 'textarea' },
        { name: 'note', label: '字典备注', type: 'textarea' }
      ],
      translationMap: {}
    }
  },
  watch: {
    dialogI18n(val) {
      if (!val) {
        this.loadTranslations('GV', this.dataList, 'id')
      }
    }
  },
  mounted () {
    console.log(localStorage.getItem('gvTypeList'))
    this.gvTypeList = localStorage.getItem('gvTypeList').split(",")
    console.log(this.gvTypeList)
    this.GvList()
    this.GvNum()
  },
  methods: {
    handleSizeChange (val) {
      this.pageSize = val
      this.GvList()
      this.GvNum()
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.GvList()
      this.GvNum()
    },
    handleSortChange ({ prop, order }) {
      this.sortField = prop || ''
      this.sortOrder = order === 'ascending' ? 'asc' : (order === 'descending' ? 'desc' : '')
      this.pageNo = 1
      this.GvList()
      this.GvNum()
    },
    clickQuery () {
      this.GvList()
      this.GvNum()
    },
    clickQueryReset () {
      this.name = ''
      this.gv = ''
      this.GvList()
      this.GvNum()
    },
    clickAdd () {
      this.dialogAdd = true
      this.addForm.type = this.gvtype
      this.addForm.name = ''
      this.addForm.gv = ''
      this.addForm.gv2 = ''
      this.addForm.gv3 = ''
      this.addForm.note = ''
    },
    clickI18n (row) {
      this.i18nEntityId = row.id
      // 根据 GV 的 name 判断是否为需要翻译内容的类型（协议/政策/须知）
      if (row.name && (row.name.indexOf('协议') !== -1 || row.name.indexOf('政策') !== -1 || row.name.indexOf('须知') !== -1)) {
        this.i18nFields = [
          { name: 'name', label: '字典名称', type: 'textarea' },
          { name: 'note', label: '字典备注', type: 'textarea' },
          { name: 'gv', label: '内容', type: 'textarea' }
        ]
      } else {
        this.i18nFields = [
          { name: 'name', label: '字典名称', type: 'textarea' },
          { name: 'note', label: '字典备注', type: 'textarea' }
        ]
      }
      this.dialogI18n = true
    },
    clickEdit (row) {
      this.dialogEdit = true
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.gv3 = row.gv3
      this.editForm.note = row.note
      this.editForm.sortOrder = row.sortOrder
    },
    clickDetail (row) {
      this.dialogDetail = true
      this.detailForm.id = row.id
      this.detailForm.type = row.type
      this.detailForm.name = row.name
      this.detailForm.gv = row.gv
      this.detailForm.gv2 = row.gv2
      this.detailForm.gv3 = row.gv3
      this.detailForm.note = row.note
    },
    clickUeditor(row){
      this.dialogUeditor = true
      this.editForm.id = row.id
      this.editForm.type = row.type
      this.editForm.name = row.name
      this.editForm.gv = row.gv
      this.editForm.gv2 = row.gv2
      this.editForm.gv3 = row.gv3
      this.editForm.note = row.note
      this.ueditorContent = row.gv
      this.editForm.gv3 = row.gv3
    },
    GoBack(){
      this.dialogUeditor = false
    },
    GvList: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.pageNo = that.pageNo
      data.pageSize = that.pageSize
      data.sortField = that.sortField
      data.sortOrder = that.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvList, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataList = response.data.data
            that.loadTranslations('GV', that.dataList, 'id')
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    loadTranslations: function (entityType, list, idField) {
      var that = this
      if (!list || list.length === 0) {
        that.translationMap = {}
        return
      }
      var ids = list.map(function(item) { return item[idField] }).join(',')
      var data = Vue.prototype.FunGetBaseSignData()
      data.entityType = entityType
      data.entityIds = ids
      data.sign = Vue.prototype.FunGetSign(data)
      axios.get(Vue.prototype.global.Url_I18nBatchList, { params: data })
        .then(function(response) {
          if (response.data.code === 1) {
            that.translationMap = response.data.data || {}
          }
        })
        .catch(function(error) {
          console.log(error)
        })
    },
    GvNum: function () {
      var that = this
      var data = Vue.prototype.FunGetBaseSignData()
      data.parentId = that.selectParentId
      data.type = that.gvtype
      data.name = that.name
      data.gv = that.gv
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvNum, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunRemindOnlyError(response.data)
          if (response.data.code === 1) {
            that.dataListnum = response.data.data
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    GvUpdate: function (pType) {
      var that = this
      var loading = that.$loading({ lock: true, text: '保存中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      var data = Vue.prototype.FunGetBaseSignData()
      data.id = that.editForm.id
      data.type = that.editForm.type
      data.name = that.editForm.name
      data.gv = that.editForm.gv
      if(pType == 2){
        data.gv = that.ueditorContent
      }
      data.gv2 = that.editForm.gv2
      if (that.editForm.gv3) {
        data.gv3 = that.editForm.gv3
      }
      data.note = that.editForm.note
      data.sortOrder = that.editForm.sortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdate, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.dialogEdit = false
            that.dialogUeditor = false
            that.GvList()
            that.GvNum()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(function () {
          loading.close()
        })
    },
    GvInsert: function () {
      var that = this
      // 必填校验
      if (!that.addForm.type || that.addForm.type.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典分类')
        return
      }
      if (!that.addForm.name || that.addForm.name.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典名称')
        return
      }
      if (!that.addForm.gv || that.addForm.gv.trim() === '') {
        Vue.prototype.FunRemindAllways('请输入字典数据主')
        return
      }
      that.addLoading = true
      var data = Vue.prototype.FunGetBaseSignData()
      data.type = that.addForm.type
      data.name = that.addForm.name
      data.gv = that.addForm.gv
      data.gv2 = that.addForm.gv2
      if (that.addForm.gv3) {
        data.gv3 = that.addForm.gv3
      }
      data.note = that.addForm.note
      data.sign = Vue.prototype.FunGetSign(data)
      var loading = that.$loading({ lock: true, text: '提交中...', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' })
      axios.post(Vue.prototype.global.Url_GvAdd, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.dialogAdd = false
            that.GvList()
            that.GvNum()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
        .finally(function () {
          loading.close()
        })
    },
    clickDelete (row) {
      var that = this
      this.$deleteConfirm('确定删除该字典项吗？删除后不可恢复').then(function () {
        var data = Vue.prototype.FunGetBaseSignData()
        data.id = row.id
        data.sign = Vue.prototype.FunGetSign(data)
        axios.post(Vue.prototype.global.Url_GvDelete, Qs.stringify(data))
          .then(function (response) {
            if (response.data.code === 1) {
              Vue.prototype.$message.success('删除成功')
              that.GvList()
              that.GvNum()
              that.refreshGvCache()
            } else {
              Vue.prototype.FunRemindAllways(response.data.msg)
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }).catch(function () {
        // 用户取消删除
      })
    },
    clickMoveUp (index, row) {
      if (index === 0) {
        Vue.prototype.FunRemindAllways('已经是第一条了')
        return
      }
      var that = this
      var prevRow = that.dataList[index - 1]
      var data = Vue.prototype.FunGetBaseSignData()
      var newCurrentSortOrder = prevRow.sortOrder
      var newPrevSortOrder = row.sortOrder
      // 当排序号相同时，确保交换后有差异
      if (newCurrentSortOrder === newPrevSortOrder) {
        newCurrentSortOrder = prevRow.sortOrder - 1
      }
      data['sortList[0].id'] = row.id
      data['sortList[0].sortOrder'] = newCurrentSortOrder
      data['sortList[1].id'] = prevRow.id
      data['sortList[1].sortOrder'] = newPrevSortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.GvList()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    clickMoveDown (index, row) {
      if (index === this.dataList.length - 1) {
        Vue.prototype.FunRemindAllways('已经是最后一条了')
        return
      }
      var that = this
      var nextRow = that.dataList[index + 1]
      var data = Vue.prototype.FunGetBaseSignData()
      var newCurrentSortOrder = nextRow.sortOrder
      var newNextSortOrder = row.sortOrder
      // 当排序号相同时，确保交换后有差异
      if (newCurrentSortOrder === newNextSortOrder) {
        newCurrentSortOrder = nextRow.sortOrder + 1
      }
      data['sortList[0].id'] = row.id
      data['sortList[0].sortOrder'] = newCurrentSortOrder
      data['sortList[1].id'] = nextRow.id
      data['sortList[1].sortOrder'] = newNextSortOrder
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvUpdateSort, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            Vue.prototype.$message.success('操作成功')
            that.GvList()
            that.refreshGvCache()
          } else {
            Vue.prototype.FunRemindAllways(response.data.msg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    refreshGvCache: function () {
      var data = Vue.prototype.FunGetBaseSignData()
      data.sign = Vue.prototype.FunGetSign(data)
      axios.post(Vue.prototype.global.Url_GvRefreshCache, Qs.stringify(data))
        .then(function (response) {
          if (response.data.code === 1) {
            var cacheData = response.data.data
            localStorage.setItem('aptustwoGvListActionType', JSON.stringify(cacheData.aptustwoGvListActionType))
            localStorage.setItem('aptustwoGvListBodyType', JSON.stringify(cacheData.aptustwoGvListBodyType))
            localStorage.setItem('aptustwoGvListMuscleRoup', JSON.stringify(cacheData.aptustwoGvListMuscleRoup))
            localStorage.setItem('aptustwoGvListAccessories', JSON.stringify(cacheData.aptustwoGvListAccessories))
            localStorage.setItem('aptustwoGvListUseLocation', JSON.stringify(cacheData.aptustwoGvListUseLocation))
            localStorage.setItem('aptustwoGvListCourseType', JSON.stringify(cacheData.aptustwoGvListCourseType))
            localStorage.setItem('aptustwoGvListCourseDifficulty', JSON.stringify(cacheData.aptustwoGvListCourseDifficulty))
            localStorage.setItem('aptustwoGvListCourseTimeType', JSON.stringify(cacheData.aptustwoGvListCourseTimeType))
            localStorage.setItem('aptustwoGvListTrainPlanClassification', JSON.stringify(cacheData.aptustwoGvListTrainPlanClassification))
            localStorage.setItem('aptustwoGvListTrainPlanType', JSON.stringify(cacheData.aptustwoGvListTrainPlanType))
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>
/* ============================================================
 *  DictionaryManagement · 项目统一设计规范
 *  主色: #2563EB (深海蓝)  强调色: #FF6F00 (活力橙)
 * ============================================================ */

.dict-page {
  --aptus-primary: #2563EB;
  --aptus-primary-light: #3B82F6;
  --aptus-primary-bg: #EFF6FF;
  --aptus-accent: #FF6F00;
  --aptus-accent-bg: #FFF5EB;
  --aptus-success: #2E7D32;
  --aptus-success-bg: #EDF7ED;
  --aptus-danger: #C62828;
  --aptus-danger-bg: #FDECEC;
  --aptus-warning: #F57F17;
  --aptus-surface: #FFFFFF;
  --aptus-surface-muted: #F5F6F8;
  --aptus-border: #E2E6EC;
  --aptus-border-light: #EFF1F5;
  --aptus-text: #1A1D21;
  --aptus-text-secondary: #5E6670;
  --aptus-text-muted: #9AA3B0;

  width: 100%;
  height: calc(100vh - 88px);
  max-height: calc(100vh - 88px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}

.main_r {
  height: 100%;
  padding: 16px 20px 14px;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  box-sizing: border-box;
}

.page-top {
  flex-shrink: 0;
  margin-bottom: 12px;
}

/* 页面标题 */
.title_line {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 700;
  color: var(--aptus-text);
  display: flex;
  align-items: center;
  gap: 10px;

  &::before {
    content: '';
    width: 4px;
    height: 22px;
    background: linear-gradient(180deg, var(--aptus-primary) 0%, var(--aptus-primary-light) 100%);
    border-radius: 2px;
  }
}

/* 筛选栏 */
.filter-strip {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  padding: 10px 14px;
  background: var(--aptus-surface);
  border: 1px solid var(--aptus-border);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(15, 26, 46, 0.04);
}

.filter-strip__fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px 12px;
  flex: 1;
  min-width: 0;
}

.filter-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.filter-field--compact {
  /deep/ .el-input,
  /deep/ .el-select,
  /deep/ .el-date-editor {
    width: 100%;
  }
}

.filter-field__label {
  font-size: 12px;
  color: var(--aptus-text-secondary);
  font-weight: 500;
  line-height: 1;
  margin-bottom: 4px;
}

.filter-strip__actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 8px;

  /deep/ .el-button {
    margin-left: 0;
  }
}

.filter-strip__sep {
  width: 1px;
  height: 24px;
  background: var(--aptus-border);
  margin: 0 2px;
}

/* 表格区域 */
.table-section {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  margin-top: 12px;
}

.table-container {
  position: relative;
  flex: 1;
  min-height: 0;
  width: 100%;
  background: var(--aptus-surface);
  border-radius: 8px;
  border: 1px solid var(--aptus-border);
  overflow: hidden;
}


/* 分页 */
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  flex-shrink: 0;
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid var(--aptus-border);
}

/* 富文本弹窗 */
.ueditor-dialog /deep/ .el-dialog__body {
  padding: 16px 20px;
}

.ueditor-dialog-body {
  min-height: 400px;
}

/* 弹窗样式 */
.newAdd /deep/ .el-dialog {
  display: flex;
  flex-direction: column;
  max-height: 80vh;
  margin-top: 10vh !important;
}

.newAdd /deep/ .el-dialog__body {
  padding: 20px;
  overflow-y: auto;
  flex: 1;
}

.newAdd /deep/ .el-dialog__header {
  padding: 18px 24px;
  background: var(--aptus-surface-muted);
  border-bottom: 1px solid var(--aptus-border-light);
}

.newAdd /deep/ .el-dialog__headerbtn {
  top: 20px;
  right: 20px;
}

.newAdd /deep/ .el-dialog__title {
  font-size: 16px;
  font-weight: 600;
  color: var(--aptus-text);
}

.newAdd /deep/ .el-dialog__footer {
  padding: 16px 24px;
  text-align: right;
  border-top: 1px solid var(--aptus-border-light);
}

.detailDialog /deep/ .el-dialog__body {
  padding: 20px;
}

/* 按钮主题覆盖 */
/deep/ .el-button--primary {
  color: #FFF;
  background-color: var(--aptus-primary);
  border-color: var(--aptus-primary);
  font-weight: 500;
  border-radius: 6px;

  &:hover {
    background-color: var(--aptus-primary-light);
    border-color: var(--aptus-primary-light);
    box-shadow: 0 2px 8px rgba(21, 101, 192, 0.25);
  }
}

/deep/ .el-button--primary.is-plain {
  color: var(--aptus-primary);
  background: var(--aptus-primary-bg);
  border-color: #A8D0F5;

  &:hover {
    background: var(--aptus-primary);
    color: #FFF;
    border-color: var(--aptus-primary);
  }
}

/* 通用表单 */
.el-form-item {
  margin-bottom: 16px;
}

/* 详情文本 */
.detailText {
  min-height: 40px;
  line-height: 22px;
  padding: 9px 15px;
  color: #606266;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-sizing: border-box;
  word-break: break-all;
}

.detailTextArea {
  white-space: pre-wrap;
}

/* 字典标签 */
.dict-tag {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 60px;
  padding: 0 8px;
  height: 22px;
  line-height: 22px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 4px;
  letter-spacing: 0.2px;
}

.dict-tag--success {
  color: var(--aptus-success);
  background: var(--aptus-success-bg);
  border: 1px solid #A5D6A7;
}

.dict-tag--danger {
  color: var(--aptus-danger);
  background: var(--aptus-danger-bg);
  border: 1px solid #EF9A9A;
}

.dict-tag--empty {
  color: var(--aptus-text-muted);
  background: transparent;
  border: 1px solid transparent;
}

/* 表格内容行优化 */
.dict-table {
  /deep/ .el-table__body td {
    padding: 12px 0;
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__body tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ .el-table .cell {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    line-height: 20px;
    font-size: 13px;
    color: var(--aptus-text);
  }

  /deep/ .el-table__header th {
    padding: 12px 0;
    background: var(--aptus-surface-muted) !important;
    border-bottom: 1px solid var(--aptus-border);
    color: var(--aptus-text-secondary);
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  /deep/ .el-table__header th .cell {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
    word-break: keep-all;
    line-height: 20px;
    padding: 0 8px;
  }

  /deep/ .el-table__header th .caret-wrapper {
    flex-shrink: 0;
    margin-left: 4px;
    vertical-align: middle;
  }

  /deep/ .el-table__fixed-right-patch {
    background: var(--aptus-surface-muted);
  }

  /deep/ .el-table__fixed-header-wrapper th,
  /deep/ .el-table__fixed .el-table__fixed-header-wrapper th {
    background: var(--aptus-surface-muted) !important;
  }

  /deep/ .el-table__fixed-body-wrapper td {
    background: var(--aptus-surface);
    border-bottom: 1px solid var(--aptus-border-light);
  }

  /deep/ .el-table__fixed-body-wrapper tr:hover > td {
    background: var(--aptus-primary-bg) !important;
  }

  /deep/ thead tr th {
    border-radius: 0 !important;
  }

  /deep/ .el-table__empty-block {
    padding: 40px 0;
  }

  /deep/ .el-table__empty-text {
    color: var(--aptus-text-muted);
    font-size: 13px;
  }
}

/* 操作按钮组优化 */
.action-group {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  white-space: nowrap;

  .el-link {
    font-size: 14px;
    padding: 5px 6px;
    border-radius: 6px;
    transition: all 200ms ease;
    line-height: 1;

    &:hover {
      background-color: var(--aptus-primary-bg);
      transform: translateY(-1px);
    }

    &.el-link--primary:hover {
      background-color: var(--aptus-primary-bg);
      color: var(--aptus-primary);
    }

    &.el-link--danger:hover {
      background-color: var(--aptus-danger-bg);
      color: var(--aptus-danger);
    }
  }
}

/* 响应式 */
@media (max-width: 1400px) {
  .filter-strip {
    flex-wrap: wrap;
  }

  .filter-strip__fields {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    width: 100%;
  }

  .filter-strip__actions {
    width: 100%;
    justify-content: flex-end;
  }
}

@media (max-width: 768px) {
  .dict-page {
    padding: 10px;
  }

  .filter-strip__fields {
    grid-template-columns: 1fr 1fr;
  }
}
</style>
